import { render } from "./Integrations.vue?vue&type=template&id=0cb28c16&ts=true"
import script from "./Integrations.vue?vue&type=script&lang=ts"
export * from "./Integrations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__